module.exports = require("zlib");


//////////////////
// WEBPACK FOOTER
// external "zlib"
// module id = 365
// module chunks = 0